<div style="text-align: center; margin-top: 5vh" *ngIf="banner && banner.image && banner.image.id">
  <img
    class="img-shadow shadow"
    style="max-width: 100%; width: 100%; max-height: 500px; min-height: 200px; border: 2px solid white"
    [src]="getImage(banner.image.id, null)"
    [alt]="banner.image?.alt ?? banner.title" />
</div>
